import PropTypes from 'prop-types';
import styled from 'helpers/styles';
import {css} from 'styled-components';
import ComponentStyles from 'styles/mixins/Component.styles';
import utils from 'helpers/utils';

const StyledChipList = styled.ul
  .attrs((props) => {
    let attr = props;

    const vars = {
      '--chip-list-item-max-width': props.theme.layout(props.$maxWidth)
    };

    return utils.styleProps(attr, vars);
  })`
  width: 100%;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  list-style: none;
  
  padding: 0;
  margin: 0;
  gap: ${props => props.theme.layout(2)};

  > li {
    margin: 0;
    overflow: hidden;
    max-width: 100%;

    ${props => (props.$maxWidth > 0) ? css`
      &.ChipList-item.ChipList-item {
        &:has(+ .ChipList-overflow-wrapper), &:last-child {
          max-width: ${props.$css.$var('--chip-list-item-max-width', false)} !important;
        }
      }
    ` : css``}
    
    .Span:has(.Chip) {
      max-width: 100% !important;
    }
  }
  
  &.ChipList-tooltip {
    font-size: ${props => props.theme.fontSize(16)};
    padding: ${props => props.theme.spacing(4/8)} 0;
    flex-direction: column;
    flex-wrap: nowrap;
    align-items: center;
    
    > li {
      width: 100%;
      display: flex;
      justify-content: center;
      
      > * {
        max-width: 100% !important;
      }
    }
  }
  
  &.ChipList-compact {
    overflow: hidden;
    flex-wrap: wrap;
    align-items: flex-start;

    &.ChipList-compact-nowrap {
      align-items: center;
      flex-wrap: nowrap;
    }

    > li {
      overflow: unset;
      display: inline-flex;
      align-items: flex-start;
    }
  }
  
  &.ChipList-density-sparse {
    gap: ${props => props.theme.layout(4)};
  }
  &.ChipList-density-sparser {
    gap: ${props => props.theme.layout(8)};
  }

  ${ComponentStyles}
`;

StyledChipList.propTypes = {
  theme: PropTypes.object
};

export default StyledChipList;
